import { OrderedMap, Map, fromJS } from 'immutable';
import * as constants from './constants';
import { LOGOUT } from '../loginSystem/constants';

export const createDefaultState = () =>
  fromJS({
    utensils: OrderedMap(),
    isFetching: false,
    fetchError: null,
    isAllFetched: false,
    marketUtensils: Map(),
    isFetchingUtensils: false,
    fetchUtensilsError: null
  });

// Transform list of objects to object with the ids as keys
const mergeUtensils = (state, utensils) =>
  state
    .get('utensils')
    .merge(
      utensils.reduce(
        (map, utensil) => map.set(utensil.id, fromJS(utensil)),
        OrderedMap()
      )
    );

const mergeMarketUtensils = (state, utensils) =>
  state
    .get('marketUtensils')
    .merge(
      utensils.reduce(
        (map, utensil) => map.set(utensil.id, fromJS(utensil)),
        OrderedMap()
      )
    );

export default function reducer(
  state = createDefaultState(),
  { type, payload }
) {
  switch (type) {
    case LOGOUT:
      return createDefaultState();
    case constants.FETCH_UTENSILS:
      return state.set('isFetching', true).set('fetchError', null);
    case constants.FETCH_UTENSILS_DONE:
      return state
        .set('utensils', mergeUtensils(state, payload))
        .set('fetchError', null)
        .set('isFetching', false)
        .set('isAllFetched', true);
    case constants.FETCH_UTENSILS_FAIL:
      return state.set('fetchError', fromJS(payload)).set('isFetching', false);

    case constants.FETCH_MARKET_UTENSILS:
      return state
        .set('isFetchingUtensils', true)
        .set('fetchUtensilsError', null);
    case constants.FETCH_MARKET_UTENSILS_DONE:
      return state
        .set('marketUtensils', fromJS(payload))
        .set('fetchUtensilsError', null)
        .set('isFetchingUtensils', false);
    case constants.FETCH_MARKET_UTENSILS_FAIL:
      return state
        .set('fetchUtensilsError', fromJS(payload))
        .set('isFetchingUtensils', false);
    default:
      return state;
  }
}
